// @spec IAM-STR-008
// @spec SHL-STR-005
import { createFileRoute, Outlet } from '@tanstack/react-router';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/settings')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.settings'),
  }),
  component: SettingsLayout,
});

/**
 * Settings layout wrapping all settings pages.
 *
 * Provides consistent layout for settings-related pages like
 * profile, security, notifications, etc.
 */
function SettingsLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Outlet />
    </div>
  );
}
